// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","h1":"About_h1__sNzj5","p":"About_p__Ur6iY","img":"About_img__ThOzN"};